interface ClientFeatures {
  isMsie?: boolean;
  isMobile?: boolean;
  isTouchSupported?: boolean;
}

const clientFeatures: ClientFeatures = {};

export const isClientMsie = () => {
  if (typeof clientFeatures.isMsie === "undefined") {
    clientFeatures.isMsie = !(
      navigator.userAgent.indexOf("MSIE") === -1 && navigator.userAgent.indexOf("Trident") === -1
    );
  }
  return clientFeatures.isMsie;
};

export const isClientMobile = () => {
  if (typeof clientFeatures.isMobile === "undefined") {
    clientFeatures.isMobile =
      isClientTouchSupported() &&
      (typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1);
  }
  return clientFeatures.isMobile;
};

export const isClientTouchSupported = () => {
  if (typeof clientFeatures.isTouchSupported === "undefined") {
    clientFeatures.isTouchSupported = !!("ontouchstart" in document && document.documentElement);
  }
  return clientFeatures.isTouchSupported;
};
